import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid,
  Typography, IconButton, Snackbar, Box, FormControl, Radio, RadioGroup, FormLabel, FormControlLabel, Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';  // Correct import for CloseIcon

import { faCloudArrowUp, faXmark, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {  postFormRequest } from '../../Utils/AxiosFetch';
import { handlingCatchError } from '../../Utils/ErrorHandling';
import { apiCommonTrigger } from '../../Utils/apiServicehelper';
import { Config } from '../../Utils/Config';

const initialFormData = {
  name: '',
  email: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipcode: '',
  phonenumber: '',
  url: '',
  description: '',
  files: [],
  missingpropertyid: '',
};

const MarketProperty = (props) => {

  const [formData, setFormData] = useState(initialFormData);
  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [stateList, setStateList] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackType, setSnackType] = useState('');
  const [propertyOptions, setPropertyOption] = useState([]);


  const fetchStateListData = async () => {
    try {
      const response = await apiCommonTrigger("get" ,Config.API_URL + '/Lookup/states')
      setStateList(response.data);
    } catch (error) {
      handlingCatchError(error);
    }
  };

  const getMissingPropertyData = async () => {
    try {
      const missingResponse = await apiCommonTrigger("get" , Config.API_URL + '/Lookup/missingproperty')
      setPropertyOption(missingResponse.data);
    } catch (error) {
      handlingCatchError(error);
    }
  }
 const fetchUserDetail = () => {
    setLoading(true);
    apiCommonTrigger("get",Config.API_URL+"/account/userdetails")
    .then((res) => {
        if (res.status === 200) {
          let userDetails=res.data.user.userdetail;
         setFormData((pre)=>({...pre,name:userDetails.firstname || "",email:userDetails?.email || ""}))
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        handlingCatchError(err);
      });
  };
  useEffect(() => {
    fetchStateListData();
    getMissingPropertyData();
    fetchUserDetail()
  }, []);

  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };


  let commonClassName = "property-common-btn";
  if (props.fromPage) commonClassName = commonClassName + ` ${props.fromPage}`;

  const handleCloseCancle = () => {
    setIsOpen(false);
  };

  const handleChange = (e) => {
    const { id, value, name } = e.target;

    if (errors[id]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [id]: undefined,
      }));
    }

    if (name === 'missingpropertyid') {
      if (errors.missingpropertyid) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          missingpropertyid: undefined,
        }));
      }
      setFormData({
        ...formData,
        missingpropertyid: parseInt(value),
      });
    } else if (id === "state") {
      setFormData({
        ...formData,
        state: value,
        zipcode: '',
      });
    } else if (id === "phonenumber") {
      const cleanedValue = formatPhoneNumber(value.replace(/[^0-9]/g, "").slice(0, 10));
      setFormData({
        ...formData,
        [id]: cleanedValue,
      });
    } else if (id === "zipcode") {
      let cleanedValue = value.replace(/[^A-Za-z0-9 ]/g, "").slice(0, 7); // Basic cleanup for zipcode
      setFormData({
        ...formData,
        [id]: cleanedValue,
      });
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };


  const trimValue = (value) => value.trim();

  // Function to format the phone number
  const formatPhoneNumber = (value) => {

    if (value.length === 10) {
      const part1 = value.slice(0, 3);
      const part2 = value.slice(3, 6);
      const part3 = value.slice(6, 10);
      return `(${part1})-${part2}-${part3}`;
    }

    return value;
  }

  const validate = () => {
    let tempErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

    if (!trimValue(formData.name)) tempErrors.name = "Name is required";
    if (!trimValue(formData.email)) tempErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email)) tempErrors.email = "Invalid email format";
    if (!trimValue(formData.address1)) tempErrors.address1 = "Address Line 1 is required";
    if (!trimValue(formData.city)) tempErrors.city = "City is required";
    if (!formData.state) tempErrors.state = "State is required";
    if (!formData.phonenumber) tempErrors.phonenumber = "Phone Number is required";
    if (!trimValue(formData.zipcode)) {
      tempErrors.zipcode = "Zip/Postal Code is required";
    } else if (formData.zipcode.length > 6) {
      tempErrors.zipcode = "Zip/Postal Code must be up to 6 characters"; // Apply general rule for length
    }

    if (formData.url && !urlRegex.test(formData.url)) {
      tempErrors.url = "Invalid URL";
    }

    if (!formData.missingpropertyid) {
      tempErrors.missingpropertyid = "Property type is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    setError('');

    try {
      const formDataToSubmit = new FormData();

      // Append form data
      Object.keys(formData).forEach(key => {
        if (key === 'files') {
          formData.files.forEach((files) => {
            formDataToSubmit.append('files', files);
          });
        } else if (key === 'name' || key === 'address1' || key === 'address2' || key === 'city' || key === 'description') {
          formDataToSubmit.append(key, (formData[key]).replace(/\s{2,}/g, ' ').trim());
        } else if (key === 'state') {
          const stateCode = formData.state.split(',')[0];
          formDataToSubmit.append(key, stateCode);
        } else {
          formDataToSubmit.append(key, formData[key]);
        }
      });

      await postFormRequest({ url: "/account/missingfacility", requestConfig: formDataToSubmit }, true);
      setSnackMessage('Your request has been submitted successfully!');
      setSnackOpen(true);
      setFormData(initialFormData);
    } catch (err) {
      setError('An error occurred. Please try again.');
      setSnackMessage('An error occurred. Please try again.');
      setSnackOpen(true);

      console.log("err", err)
      handlingCatchError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    let updatedFiles = [...formData.files];
    let tempErrors = {};

    newFiles.forEach(file => {
        if (file.size > 5 * 1024 * 1024) { // 5 MB limit
            tempErrors.file = `${file.name} exceeds 5MB size limit`;
        } else if (updatedFiles.length >= 3) {
            tempErrors.file = "You can only upload up to 3 files.";
        } else {
            updatedFiles.push(file);
        }
    });

    if (Object.keys(tempErrors).length > 0) {
        setErrors(tempErrors);
    } else {
        setErrors({});
    }

    setFormData({
        ...formData,
        files: updatedFiles.slice(0, 3),
    });
};

const removeFile = (index) => {
  const updatedFiles = formData.files.filter((_, i) => i !== index);
  setErrors({});
  setFormData({
      ...formData,
      files: updatedFiles,
  });
};

  return (
    <>
      <button className={commonClassName} onClick={() => { setIsOpen(true); }} > <FontAwesomeIcon icon={faCircleQuestion} /> Missing Property or Development </button>
      
      <Dialog open={isOpen} onClose={handleCloseCancle} fullWidth maxWidth="lg" className='submit_missing_popup'>
      <button onClick={handleCloseCancle} className='missingprop-close'>
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackOpen}
          autoHideDuration={6000}
          onClose={handleSnackClose}
          message={snackMessage}
          ContentProps={{
            style: {
              backgroundColor: snackType === 'error' ? 'red' : 'green',
              color: 'white',
            },
          }}
          action={
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        />
        <DialogTitle className='popup-title-head'>Submit Missing Facility or Development</DialogTitle>
        <DialogContent  className='miss-facility-devp'>
          <Grid container spacing={3}>
            {/* Left side form */}
            <Grid item xs={12} md={8} className='head-top-text'>
              <form onSubmit={handleSubmit} className='miss-prop-devpt-popup-form '>
                <Grid container spacing={2}>
                  <Grid item xs={6} style={{paddingLeft:"0px"}}>
                    <TextField
                      fullWidth
                      label="Your Name"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      variant="outlined"
                      error={!!errors.name}
                      helperText={errors.name}
                      
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      variant="outlined"
                      error={!!errors.email}
                      helperText={errors.email}
                     
                    />
                  </Grid>
                  <Box className='property-box'>
                    <Typography className='property-title'>Property details</Typography>
                    <Grid item xs={12} className='mb-1 pt-0'>
                      <FormControl component="fieldset" className='property-radio'>
                        <RadioGroup
                          row
                          name='missingpropertyid'
                          value={formData.missingpropertyid}
                          onChange={handleChange}
                        >
                          <Typography variant="subtitle2" className='pr-2 pl-0'>Property Type:</Typography>
                          <div className='facility-devep-radio'>
                          {propertyOptions.map((option) => (
                            <FormControlLabel
                              key={option.id}
                              value={option.id}
                              control={<Radio />}
                              label={option.name}
                            />
                          ))}
                          </div>
                        </RadioGroup>
                        {errors.missingpropertyid && (
                          <Typography color="error" variant="body2" className='missing-property_error'>
                            {errors.missingpropertyid}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Address Line 1"
                          id="address1"
                          value={formData.address1}
                          onChange={handleChange}
                          variant="outlined"
                          error={!!errors.address1}
                          helperText={errors.address1}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Address Line 2"
                          id="address2"
                          value={formData.address2}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="City"
                            id="city"
                            value={formData.city}
                            onChange={handleChange}
                            variant="outlined"
                            error={!!errors.city}
                            helperText={errors.city}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              select
                              SelectProps={{ native: true }}
                              id="state"
                              value={formData.state}
                              onChange={handleChange}
                              variant="outlined"
                              error={!!errors.state}
                              helperText={errors.state}
                              className='dropdown-pop-fld'
                              style={{ color: formData.state === "US,US" ? 'gray' : 'inherit' }}>
                              <option value="">Select State</option>
                              {stateList.map((state) => (
                                <option
                                  key={state.value || ""}
                                  value={state.label === "" ? "" : state.label}
                                  disabled={state.statename === "United States" || state.statename === "Canada"}
                                  style={{
                                    color: 'inherit',
                                    backgroundColor: (state.statename === "United States" || state.statename === "Canada") ? 'lightgray' : 'inherit' // Use lightgray for better visibility
                                  }}
                                >
                                  {state.statename}
                                </option>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={6}>
                            <Tooltip
                              title={!formData.state ? "Select state first" : ""}
                              arrow
                            >
                              <span>
                                <TextField
                                  fullWidth
                                  label="Zip/Postal Code"
                                  id="zipcode"
                                  value={formData.zipcode}
                                  onChange={handleChange}
                                  variant="outlined"
                                  error={!!errors.zipcode}
                                  helperText={errors.zipcode}
                                  disabled={!formData.state}
                                  InputProps={{ readOnly: !formData.state }}
                                />
                              </span>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Phone"
                          id="phonenumber"
                          value={formData.phonenumber}
                          onChange={handleChange}
                          variant="outlined"
                          error={!!errors.phonenumber}
                          helperText={errors.phonenumber}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Website URL"
                          id="url"
                          value={formData.url}
                          onChange={handleChange}
                          variant="outlined"
                          error={!!errors.url}
                          helperText={errors.url}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label={<span className='test-data'>Description and details of facility or development. Please include and relevant
                            data points such as square footage, type of zoning, etc</span>}
                          id="description"
                          value={formData.description}
                          onChange={handleChange}
                          variant="outlined"
                          multiline
                          rows={4}
                          className='textarea-ht'
                        />
                      </Grid>
                      <Grid item xs={12} >
                        <div className="upload-container">
                          <div className="upload-area" id="uploadArea">
                            <FontAwesomeIcon
                              icon={faCloudArrowUp}
                              style={{ color: formData.files.length >= 3 ? 'gray' : 'blue' }}
                            />
                            <div>
                              {errors.file ? (
                                <Typography variant="body2" color="error">
                                  {errors.file}
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="textSecondary" style={{ marginLeft: '10px' }}>
                                  Attach supporting documents (up to 3 files - .docx/.pdf/.xlsx/.jpeg/.jpg), this helps with our verification process. (optional)
                                </Typography>
                              )}
                            </div>
                            <input
                              type="file"
                              id="fileInput"
                              onChange={handleFileChange}
                              multiple
                              accept=".pdf, .doc, .docx, .xlsx, .jpeg, .jpg"
                              disabled={formData.files.length === 3}
                              style={{ marginTop: '10px', display: 'block' }}
                            />
                            <div className="file-list-container" style={{ marginTop: '10px' }}>
                              {formData.files.length > 0 ? (
                                <div>
                                  {formData.files.map((file, index) => {
                                    const truncatedFileName =
                                      file.name.length > 20 ? file.name.slice(0, 45) + '...' : file.name;
                                    return (
                                      <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <Typography variant="body2" style={{ marginLeft: '10px' }}>
                                          {truncatedFileName}
                                        </Typography>
                                        <IconButton
                                          aria-label="remove file"
                                          onClick={() => removeFile(index)}
                                          style={{ marginLeft: '10px' }}
                                        >
                                          <FontAwesomeIcon icon={faXmark} style={{ fontSize: '15px' }} />
                                        </IconButton>
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <Typography variant="body2" color="textSecondary">
                                  No files uploaded yet.
                                </Typography>
                              )}
                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                    <DialogActions className='pr-0'>
                      <Button onClick={handleCloseCancle} color="secondary" className='miss-prop-devpt-popup-form-cancel'>
                        Cancel
                      </Button>
                      <Button type="submit" color="primary" variant="contained" disabled={loading} className='miss-prop-devpt-popup-form-submit'>
                        {loading ? 'Submitting...' : 'Submit'}
                      </Button>
                    </DialogActions>
                    {error && <Typography color="error">{error}</Typography>}
                  </Box>
                </Grid>
              </form>
            </Grid>

            {/* Right side information */}
            <Grid item xs={12} md={4} container direction="column" alignItems="flex-start" className='miss-prop-devpt-popup-form-right-text'>
              <Typography variant="h5">The RVParkIQ Research Team is on it!</Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                We will add your submitted property as soon as we verify the details. If we have any questions, we will contact you.
              </Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                If you have any additional questions, please let us know.
              </Typography>
              <Typography>
                <div className='mb-2 fromright-text'>
                  <FontAwesomeIcon icon={faPhone} /> <span> +800 337 3098 </span> </div>
                <div className='fromright-text'>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span style={{ paddingLeft: '5px' }}>support@rvparkiq.com </span></div>
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

    </>
  )
}

export default MarketProperty